import { useEffect, useState } from "react";
import { Building2 } from "lucide-react";
import api, { getViewCompanyId, setViewCompanyId } from "../services/api";

const isSuperAdmin = () => String(sessionStorage.getItem("role") || "").replace("ROLE_", "") === "SUPER_ADMIN";

/**
 * Company dropdown of a multi-company distributor (same as the mobile app's dashboard dropdown): the super admin picks another
 * company of the group and every page then works in that company. Renders nothing unless multi-company is switched
 * on for the distributor. onChange gets the picked company id, or null for the user's own company.
 */
const CompanySwitcher = ({ onChange }) => {
  const [companies, setCompanies] = useState([]);
  const ownId = sessionStorage.getItem("distributorId") || "";
  const viewId = getViewCompanyId();

  useEffect(() => {
    if (!isSuperAdmin()) return;
    let cancelled = false;
    api
      .get("/api/v1/distributor-profile/companies")
      .then((data) => {
        if (cancelled) return;
        const list = Array.isArray(data) ? data : [];
        setCompanies(list);
        // the company picked earlier is no longer in the group (or multi-company was switched off)
        const picked = getViewCompanyId();
        if (picked && !list.some((c) => String(c.distributorId) === picked)) {
          setViewCompanyId(null);
          onChange(null);
        }
      })
      .catch(() => {
        if (!cancelled) setCompanies([]);
      });
    return () => {
      cancelled = true;
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!companies.length) return null;

  const handleChange = (e) => {
    setViewCompanyId(e.target.value);
    onChange(getViewCompanyId());
  };

  return (
    <div className="company-switcher" title="Switch to another company of the group">
      <Building2 size={15} />
      <select value={viewId || ownId} onChange={handleChange} aria-label="Company">
        {companies.map((c) => (
          <option key={c.distributorId} value={c.distributorId}>
            {c.name}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CompanySwitcher;
